import 'reflect-metadata';
import './fix';
import { createApp } from 'vue';
import App from './App.vue';
import { container } from './inversify.config';
import 'element-plus/dist/index.css';
import './assets/style/main.scss';
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import './assets/style/el-overwrites.scss';
import { startup } from '@eureka/startup';
import { accountDeferred } from '@eureka/utils/account';
import { AnonymousError } from '@eureka/services/src/exception';
// import { useLoginSdk } from './composables/use-loginsdk';
import {
  ErrorHandler,
  ErrorHandlerRegistry,
  injectService,
  setContainer,
} from '@patsnap/tahiti-core';
import { i18n, loadI18n } from '@/infrastructure/locales';
import router from './routes';
import { injectFingerprintInterceptor } from '@eureka/services/src/apis/interceptors/fingerprint.interceptor';
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
import { HeaderServiceProxy } from './services/header-service-proxy';
import { useVisitorCookies } from './composables/home/use-visitor-cookies';

const { init: initCookies } = useVisitorCookies();

setContainer(container);
initCookies();
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();
injectFingerprintInterceptor();

const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy)
  .headerService as HeaderServiceProxy['headerService'];

// const { openLoginDialog } = useLoginSdk(i18n, {
//   from_page: EMPOWER_TYPE.TECH_MIND,
//   channel_source: CHANNEL_SOURCE.AIR_EUREKA,
// });

startup({
  headerService: headerServiceInstance,
  projectName: 'eureka',
  preset: {
    name: 'eureka',
    preRedirectLogin() {
      if (!headerServiceInstance?.userCenterService?.logged) {
        // openLoginDialog();
      }
      throw new AnonymousError();
    },
  },
  pageInit() {
    return Promise.resolve();
  },
  disableCustomerService: true,
});

(async () => {
  await loadI18n();
  accountDeferred.promise.then(() => {
    import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
      getHelpCenter(i18n.global, headerServiceInstance);
    });
  });
  createApp(App).use(router).use(i18n).use(SafeHtmlPlugin).mount('#app');
})();
